import * as React from "react";
const SVGComponent = ({ color = "#000", ...props }) => (
  <svg
    width={15}
    height={16}
    viewBox="0 0 15 16"
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 0.734375C3.48633 0.734375 0.234375 3.98633 0.234375 8C0.234375 12.0137 3.48633 15.2656 7.5 15.2656C11.5137 15.2656 14.7656 12.0137 14.7656 8C14.7656 3.98633 11.5137 0.734375 7.5 0.734375ZM11.7188 8.82031C11.7188 9.01367 11.5605 9.17188 11.3672 9.17188H8.67188V11.8672C8.67188 12.0605 8.51367 12.2188 8.32031 12.2188H6.67969C6.48633 12.2188 6.32812 12.0605 6.32812 11.8672V9.17188H3.63281C3.43945 9.17188 3.28125 9.01367 3.28125 8.82031V7.17969C3.28125 6.98633 3.43945 6.82812 3.63281 6.82812H6.32812V4.13281C6.32812 3.93945 6.48633 3.78125 6.67969 3.78125H8.32031C8.51367 3.78125 8.67188 3.93945 8.67188 4.13281V6.82812H11.3672C11.5605 6.82812 11.7188 6.98633 11.7188 7.17969V8.82031Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;